import * as React from 'react';

import { BookabilityRuleAlert } from './BookabilityRuleAlert';

export const InvalidCallLocationAlert: BookabilityRuleAlertComponent = ({ study, level, onClickCta }) => (
  <BookabilityRuleAlert
    level={level}
    heading='Invalid call location'
    message='Participants won’t receive a call link to join when they schedule.'
    ctas={[
      {
        children: 'Edit call location',
        href: `/studies/${study.id}/calendar`,
        onClick: onClickCta
      }
    ]}
  />
);
